import { render, staticRenderFns } from "./MStoreKanbanLanes.vue?vue&type=template&id=4913d51e&"
import script from "./MStoreKanbanLanes.vue?vue&type=script&lang=ts&"
export * from "./MStoreKanbanLanes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports